<template>
  <div>
    <vue-element-loading
      :active="appLoading"
      spinner="bar-fade-scale"
      color="#1976d2"
       size="50"
      is-full-screen
    />
    <v-layout v-if="ServerError" wrap justify-center>
      <v-flex px-5 pt-5 xs12 sm12 md12 lg12 xl12 text-center>
        <ServerError />
      </v-flex>
    </v-layout>
    <v-layout justify-center wrap>
      <v-flex xs12>
        <v-layout justify-center wrap py-8 v-if="staff">
          <v-flex xs12>
            <v-card>
              <v-flex xs12>
                <v-card color="#434343" outlined class="mx-auto">
                  <v-layout justify-end wrap>
                    <v-flex xs10 px-5 align-self-end text-right>
                      <v-icon
                        color="white"
                        size="15"
                        @click="$refs.showImage.click()"
                        >mdi-folder-edit-outline</v-icon
                      >
                      <span
                        style="
                          color: white;
                          font-family: nunitosansregular;
                          font-size: 12px;"
                        >Edit Photo</span
                      >
                      <input
                        v-show="false"
                        accept="image/*"
                        id="file"
                        ref="showImage"
                        multiple="multiple"
                        type="file"
                        @change="showImage"
                      />
                    </v-flex>
                  </v-layout>
                  <v-layout justify-center wrap pt-3 pb-5 v-if="staff.user">
                    <v-flex xs12 sm12 md12 text-center>
                      <v-layout justify-center wrap>
                        <v-flex xs12>
                          <!-- <v-badge
                            @click="$refs.showImage.click()"
                            bordered
                            avatar
                            color="white"
                            bottom
                            overlap
                            offset-x="20"
                            offset-y="20"
                          >
                            <template v-slot:badge>
                              <v-avatar>
                                <v-icon color="black"
                                  >mdi-folder-edit-outline</v-icon
                                >
                              </v-avatar>
                            </template> -->
                          <v-avatar style="cursor: pointer" size="80">
                            <v-img :src="mediaURL + staff.user.photo" />
                          </v-avatar>
                          <!-- </v-badge>
                           <input
                              v-show="false"
                              accept="image/*"
                              id="file"
                              ref="showImage"
                              multiple="multiple"
                              type="file"
                              @change="showImage"
                            /> -->
                        </v-flex>
                        <v-flex xs12 pt-1>
                          <span
                            style="
                              color: #ffffff;
                              font-family: nunitosanssemibold;
                              font-size: 18px;"
                            >{{ staff.user.firstName }}
                            {{ staff.user.lastName }}</span
                          ><br />
                          <span
                            v-if="staff.allottedClass"
                            style="
                              font-family: nunitosansbold;
                              color: #ffffff;
                              font-size: 12px;"
                            >Class Teacher</span
                          >
                          <span
                            v-else
                            style="
                              font-family: nunitosansbold;
                              color: #ffffff;
                              font-size: 12px;">
                            Teacher</span
                          >
                        </v-flex>
                        <v-flex xs4 sm2 md2 lg1 py-2 v-if="staff.allottedClass">
                          <v-btn color="#9B8DFD" small rounded>
                            <span
                              style="
                                color: #ffffff;
                                font-family: nunitosansbold;"
                            >
                              {{ staff.allottedClass.className }}
                            </span>
                          </v-btn>
                        </v-flex>
                        <v-flex xs4 sm2 md2 lg1 py-2 v-if="staff.allottedClass">
                          <v-btn rounded outlined small color="white">
                            <span
                              style="
                                color: #ffffff;
                                font-family: nunitosansregular;
                                text-transform: none;"
                              >{{ staff.subject.subjectName }}</span
                            >
                          </v-btn>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>
              <v-layout justify-center wrap py-5 v-if="standard.length > 0">
                <v-flex xs11>
                  <v-card outlined>
                    <v-card-text>
                      <v-flex xs12>
                        <span
                          style="
                            color: #000000;
                            font-family: nunitosansbold;
                            font-size: 18px;"
                          >My Classes</span
                        >
                      </v-flex>
                      <v-layout justify-start wrap>
                        <v-flex xs4 sm4 md2 lg1>
                          <span
                            style="color: #4d4d4d; font-family: nunitosanslight"
                            >Class</span
                          >
                        </v-flex>
                        <v-flex xs6 sm6 md3 lg3 pl-2 text-left>
                          <span
                            style="color: #4d4d4d; font-family: nunitosanslight"
                          >
                            Division
                          </span>
                        </v-flex>
                      </v-layout>
                      <v-flex xs12 v-for="(item, i) in standard" :key="i">
                        <v-layout justify-start wrap py-2>
                          <v-flex xs4 sm4 md2 lg1 pt-2>
                            <v-btn rounded small color="#F2F2F2">{{
                              item.standard.standardName
                            }}</v-btn>
                          </v-flex>
                          <v-flex
                            xs12
                            sm4
                            md3
                            lg2
                            v-for="(list, i) in item.data"
                            :key="i"
                            ma-2
                          >
                            <span v-if="list.isClassTeacher">
                              <v-btn rounded color="#9B8DFD" small>
                                <span
                                  style="
                                    color: #ffffff;
                                    font-family: nunitosansbold;">
                                  {{ list.division.divisionName }} -
                                  {{ list.subject.subjectName }}</span
                                ></v-btn
                              >
                            </span>
                            <span v-else>
                              <v-btn rounded small outlined
                                >{{ list.division.divisionName }} -
                                {{ list.subject.subjectName }}</v-btn
                              >
                            </span>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-card-text>
                  </v-card>
                </v-flex>
              </v-layout>
              <v-layout justify-center wrap v-if="staff.user">
                <v-flex xs12>
                  <v-card-text>
                    <v-layout justify-center wrap py-5>
                      <v-flex xs12 sm12 md5>
                        <span
                          style="
                            color: #000000;
                            font-family: nunitosansbold;
                            font-size: 18px;"
                          >Personal Information</span
                        >
                        <v-layout justify-center wrap py-5>
                          <v-flex xs2 sm2 md1>
                            <v-img
                              width="25px"
                              src="../../assets/images/male black 24dp.png"
                            />
                          </v-flex>
                          <v-flex xs10 sm10 md11>
                            <span class="heading">Gender</span>
                            <br />
                            <span class="content">{{ staff.user.gender }}</span>
                          </v-flex>
                        </v-layout>
                        <v-layout justify-center wrap pb-5>
                          <v-flex xs2 sm2 md1>
                            <v-img
                              width="25px"
                              src="../../assets/images/cake black 24dp.png"
                            />
                          </v-flex>
                          <v-flex xs10 sm10 md11>
                            <span class="heading">DOB</span>
                            <br />
                            <span class="content" v-if="staff.user.dob">{{
                              staff.user.dob.slice(0, 10)
                            }}</span>
                          </v-flex> </v-layout
                        ><v-layout justify-center wrap pb-5>
                          <v-flex xs2 sm2 md1>
                            <v-img
                              width="25px"
                              src="../../assets/images/phone iphone black 24dp.png"
                            />
                          </v-flex>
                          <v-flex xs10 sm10 md11>
                            <span class="heading">Contact</span>
                            <br />
                            <span class="content">{{ staff.user.phone }}</span>
                            <br />
                          </v-flex> </v-layout
                        ><v-layout justify-center wrap pb-5>
                          <v-flex xs2 sm2 md1>
                            <v-img
                              width="25px"
                              src="../../assets/images/home black 24dp.png"
                            />
                          </v-flex>
                          <v-flex xs10 sm10 md11>
                            <span class="heading">Address</span>
                            <br />
                            <span class="content">{{
                              staff.user.address
                            }}</span>
                          </v-flex> </v-layout
                        ><v-layout justify-center wrap pb-5>
                          <v-flex xs2 sm2 md1>
                            <v-img
                              width="25px"
                              src="../../assets/images/email black 24dp.png"
                            />
                          </v-flex>
                          <v-flex xs10 sm10 md11>
                            <span class="heading">Email</span>
                            <br />
                            <span class="content">{{ staff.user.email }}</span>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex xs12 sm12 md3>
                        <span
                          style="
                            color: #000000;
                            font-family: nunitosansbold;
                            font-size: 18px;"
                          >Emergency Information</span
                        >
                        <span v-if="staff.user.emergency">
                          <v-layout justify-center wrap py-5>
                            <v-flex xs2 pt-2>
                              <v-img
                                width="25px"
                                src="../../assets/images/phone iphone black 24dp.png"
                              />
                            </v-flex>
                            <v-flex xs10>
                              <span class="heading">Emergency</span>
                              <br />
                              <span
                                class="content"
                                v-if="staff.user.emergency"
                                >{{ staff.user.emergency.name }}</span
                              >
                            </v-flex> </v-layout
                          ><v-layout justify-center wrap pb-5>
                            <v-flex xs2 pt-2>
                              <v-img
                                width="25px"
                                src="../../assets/images/phone iphone black 24dp.png"
                              />
                            </v-flex>
                            <v-flex xs10>
                              <span class="heading">Contact</span>
                              <br />
                              <span
                                class="content"
                                v-if="staff.user.emergency"
                                >{{ staff.user.emergency.contact }}</span
                              >
                            </v-flex>
                          </v-layout>
                          <v-layout justify-center wrap pb-5>
                            <v-flex xs2 pt-2>
                              <v-img
                                width="25px"
                                src="../../assets/images/email black 24dp.png"
                              />
                            </v-flex>
                            <v-flex xs10>
                              <span class="heading">Email</span>
                              <br />
                              <span
                                class="content"
                                v-if="staff.user.emergency"
                                >{{ staff.user.emergency.email }}</span
                              >
                            </v-flex>
                          </v-layout>
                        </span>
                        <span v-else>
                          <v-flex xs12 pt-5>
                            <span class="content">No Information Provided</span>
                          </v-flex>
                        </span>
                      </v-flex>
                      <v-flex xs12 sm12 md3 text-right>
                        <v-dialog v-model="editdialog" max-width="700px">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon size="16" v-bind="attrs" v-on="on"
                              >mdi-folder-edit-outline</v-icon
                            >
                          </template>
                          <v-card>
                            <v-card-text>
                              <v-layout justify-start wrap pt-5>
                                <v-flex xs12 sm6 md6 pa-2>
                                  <v-text-field
                                    v-model="staff.user.firstName"
                                    class="text"
                                    label="First Name"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6 md6 pa-2>
                                  <v-text-field
                                    v-model="staff.user.lastName"
                                    class="text"
                                    label="Last Name"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6 md6 pa-2>
                                  <v-select
                                    dense
                                    label="Gender"
                                    outlined
                                    class="text"
                                    v-model="staff.user.gender"
                                    hide-details
                                    :items="genders"
                                  >
                                  </v-select>
                                </v-flex>
                                <v-flex xs12 sm6 md6 pa-2>
                                  <v-menu
                                    ref="menu"
                                    v-model="menu"
                                    :close-on-content-click="false"
                                    :return-value.sync="staff.user.dob"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="290px"
                                  >
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-text-field
                                        v-model="staff.user.dob"
                                        label="DOB"
                                        readonly
                                        outlined
                                        dense
                                        v-bind="attrs"
                                        v-on="on"
                                      ></v-text-field>
                                    </template>
                                    <v-date-picker
                                      v-model="staff.user.dob"
                                      max="2000-01-1"
                                      no-title
                                      scrollable>
                                      <v-spacer></v-spacer>
                                      <v-btn
                                        text
                                        color="primary"
                                        @click="menu = false">
                                        Cancel
                                      </v-btn>
                                      <v-btn
                                        text
                                        color="primary"
                                        @click="$refs.menu.save(staff.user.dob)">
                                        OK
                                      </v-btn>
                                    </v-date-picker>
                                  </v-menu>
                                </v-flex>
                                <v-flex xs12 sm6 md6 pa-2>
                                  <v-text-field
                                    v-model="staff.subject1"
                                    class="text"
                                    label="Subject"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6 md6 pa-2>
                                  <v-text-field
                                    v-model="staff.subject2"
                                    class="text"
                                    label="Subject 2"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6 md6 pa-2>
                                  <v-text-field
                                    v-model="staff.user.email"
                                    class="text"
                                    label="Email"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6 md6 pa-2>
                                  <v-text-field
                                    v-model="staff.user.phone"
                                    class="text"
                                    label="Contact"
                                    outlined
                                    type="number"
                                    dense
                                  ></v-text-field>
                                </v-flex>
                                <v-flex xs12 pa-2>
                                  <v-text-field
                                    v-model="staff.user.address"
                                    class="text"
                                    label="Address"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-flex>
                                <v-flex
                                  xs12
                                  sm6
                                  md6
                                  pa-2
                                  v-if="staff.user.emergency">
                                  <v-text-field
                                    v-model="staff.user.emergency.name"
                                    class="text"
                                    label="Emergency Name"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-flex>
                                <v-flex
                                  xs12
                                  sm6
                                  md6
                                  pa-2
                                  v-if="staff.user.emergency">
                                  <v-text-field
                                    v-model="staff.user.emergency.contact"
                                    class="text"
                                    label="Emergency Contact"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-flex>
                                <v-flex
                                  xs12
                                  sm6
                                  md6
                                  pa-2
                                  v-if="staff.user.emergency">
                                  <v-text-field
                                    v-model="staff.user.emergency.email"
                                    class="text"
                                    label="Emergency Email"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-flex>
                              </v-layout>
                            </v-card-text>
                            <v-card-actions>
                              <v-spacer></v-spacer>
                              <v-layout justify-center wrap>
                                <v-flex xs6 sm4 px-2>
                                  <v-btn
                                    block
                                    tile
                                    color="#757575"
                                    outlined
                                    :ripple="false"
                                    depressed
                                    @click="editdialog = false"
                                  >
                                    Close
                                  </v-btn>
                                </v-flex>
                                <v-flex xs6 sm4 px-2>
                                  <v-btn
                                    tile
                                    block
                                    dark
                                    color="#FF1313"
                                    depressed
                                    class="text-capitalize"
                                    :ripple="false"
                                    @click="edit()"
                                  >
                                    Save
                                  </v-btn>
                                </v-flex>
                              </v-layout>
                            </v-card-actions>
                          </v-card>
                        </v-dialog>
                        <span
                          style="
                            font-family: nunitosansregular;
                            font-size: 12px;"
                          >Edit Information</span
                        >
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
export default {
  props: ["id"],
  data() {
    return {
      hover: false,
      appLoading: false,
      ServerError: false,
      editdialog: false,
      menu: false,
      genders: ["Male", "Female", "Other"],
      cgpi: 50,
      staff: [],
      data: [],
      file1: null,
      standard: [],
      classArray: [],
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/teacher/get",
        params: {
          id: this.id,
        },
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.staff = response.data.data;
          this.staff.user.dob=this.staff.user.dob.slice(0, 10)
          this.data = response.data.classubjects;
          this.standard = response.data.standardwiseData;
          this.appLoading = false;
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    showImage(e) {
      this.file1 = e.target.files[0];
      console.log(e);
      var reader = new FileReader();
      reader.onload = (e) => {
        this.$refs.showImage.value = null;
        this.imagePreview = e.target.result;
      };
      if (this.file1.size > 2145728) {
        this.msg = "File Should be less than 2MB";
        this.showsnackbar = true;
        return;
      }
      this.showPreview = true;
      if (this.file1) {
        if (/\.(jpe?g|png|gif)$/i.test(this.file1.name)) {
          reader.readAsDataURL(this.file1);
        }
        this.uploadImage();
      }
    },
    uploadImage() {
      let formData = new FormData();
      formData.append("photo", this.file1);
      formData.append("id", this.staff.user._id);
      axios({
        method: "POST",
        url: "/User/adminUploadImage",
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data",
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status == true) {
            this.msg = "Uploaded Successully";
            this.showsnackbar = true;
            this.showPreview = null;
            this.getData();
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.showsnackbar = true;
          this.appLoading = false;
          console.log(err);
        });
    },
    edit() {
      this.appLoading = true;
      var user = {};
      user["subject1"] = this.staff.subject1;
      user["subject2"] = this.staff.subject2;
      user["firstName"] = this.staff.user.firstName;
      user["lastName"] = this.staff.user.lastName;
      user["phone"] = this.staff.user.phone;
      user["email"] = this.staff.user.email;
      user["gender"] = this.staff.user.gender;
      user["dob"] = this.staff.user.dob;
      user["emergencyName"] = this.staff.user.emergency.name;
      user["emergencyContact"] = this.staff.user.emergency.contact;
      user["emergencyEmail"] = this.staff.user.emergency.email;
      user["id"] = this.id;
      axios({
        method: "POST",
        url: "/teacher/edit",
        data: user,
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.editdialog = false;
            this.msg = "Teacher Update Successully";
            this.showsnackbar = true;
            this.getData();
          } else {
            this.editdialog = false;
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
  },
};
</script>
<style>
.heading {
  color: #4d4d4d;
  font-family: nunitosanslight;
  font-size: 12px;
}
.content {
  color: #000000;
  font-family: nunitosansregular;
}
.subject {
  color: #4d4d4d;
  font-family: nunitosansregular;
  font-size: 12px;
}
</style>